module.exports = __webpack_public_path__ + "img/nav-convert.674d19d.svg";